import { useTranslation } from "react-i18next";

const BUILD_ID = process.env.REACT_APP_BUILD_ID || "dev";

// يظهر رقم البناء حتى تعرف فوراً إن كان التطبيق يعمل بأحدث نسخة أم بنسخة قديمة.
export const BuildStamp = () => {
  const { t } = useTranslation();
  return (
    <p className="mt-4 text-center text-[11px] text-muted-foreground" data-testid="build-stamp">
      {t("app.build")} <span className="font-mono" dir="ltr">{BUILD_ID}</span>
    </p>
  );
};
